import *as React from 'react';
import './Subscription.css'
import Expand from './expandcard'
import Subscribe from './main'
import {getSessionId, getToken,getUser}from '../util'
import Modal, {
  ModalBody,
  ModalFooter,
  ModalHeader,
  ModalTitle,
  ModalTransition,
} from '@atlaskit/modal-dialog';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Button from '@mui/material/Button';
import CrossIcon from '@atlaskit/icon/glyph/cross';
import Textfield from '@atlaskit/textfield';
import FormControl from '@mui/material/FormControl';
import ContentCopyOutlinedIcon from '@mui/icons-material/ContentCopyOutlined';
import {CopyToClipboard} from 'react-copy-to-clipboard';
export default class Main extends React.Component{
  constructor(props){
    super(props)
    this.state={
      productData:[],
      modalOpen:false,
      disConnectBox:false,
      password:'',
      changePin:'',
      productCode:'',
      supportPin:'',
      productKey:'',
      userNo:'',
      copied: false,
      recordmodel:false,
      disprokey:''
     
    }
  }
  componentDidMount=()=>{

    this.ongetCustomerDetails(getUser().emailid)
  }
  onModelClick=(productcode,supportpin,productkey)=>{
    this.setState({modalOpen:true,productCode:productcode,supportPin:supportpin,productKey:productkey})  
  }
  onPinChange=()=>{
    this.setState({modalOpen:false,changePin:''})  
  }
  onDisconnect=(productkey)=>{
    this.setState({disConnectBox:true,disprokey:productkey})
  }
  closedisconnect=()=>{
    
    this.setState({disConnectBox:!this.state.disConnectBox})
  }
  ongetCustomerDetails=(emailId)=>{
    fetch(`eadmin/v1/set/get_customer_licence_details?emailId=${emailId}` ,{
      method: 'GET',
      headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      "x-access-token":getToken()
      },
      }).then((response) => response.json())
      .then((responseJson) => {
      if(responseJson.status && responseJson.result.length>0){
        this.setState({productData:responseJson.result})
        //alert(JSON.stringify(this.state.productData))
      }else if(!responseJson.status){
        alert(responseJson.errorMsg)
      }else{
         this.setState({recordmodel:true})
      }
    }).catch((error) => {
      alert(error)
    });
  }
  onPinChange=()=>{
    if(this.state.changePin===''){
      alert('Please Enter Pin Value')
    }else{
    let json_data={emailId:getUser().emailid,token:getToken(),supportPin:this.state.changePin,oldSupportPin:this.state.supportPin, productCode:this.state.productCode,productKey:this.state.productKey,
      registrationNo:getUser().registerno, sessionId:getSessionId()}
    fetch(`eadmin/v1/set/change_supportpin`, {
    method: 'POST',
    headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
    },
    body:(JSON.stringify(json_data)),
    }).then((response) => response.json())
    .then((responseJson) => {
        if(responseJson.status ){
          this.setState({modalOpen:false})
           alert('SuccessFully Changed Support PIN')
           this.setState({password:''})
           this.ongetCustomerDetails(getUser().emailid)
        } 
        else{
        alert(responseJson.errorMsg)
        }
    }).catch((error) => {
        alert(error)
    });
}
  }
licenseDisconnect=()=>{
  if(this.state.password===''){
    this.setState({disConnectBox:false})
    alert('Password Required')
  }
  else{
    let json_data={emailId:getUser().emailid,productKey:this.state.disprokey,password:this.state.password,
      sessionId:getSessionId(),
    }
   //alert(this.state.disprokey)
    fetch(`eadmin/v1/set/license_surrender`, {
    method: 'POST',
    headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
    "x-access-token":getToken()
    },
    body:(JSON.stringify(json_data)),
    }).then((response) => response.json())
    .then((responseJson) => {
      if(responseJson.status){
        this.setState({disConnectBox:false,password:''})
        alert("Disconnect SuccessFully")
        this.ongetCustomerDetails(getUser().emailid)
      } 
      else{
        alert(responseJson.errorMsg)
      }
    }).catch((error) => {
      alert(error)
    });
  }
  }  
  onrecordmodelclose=()=>{
    this.setState({recordmodel:false})
  }
  disconnectsurrendar=(productkey)=>{
    alert("LICENSEKEY IS ALREADY DISCONNECTED")
  }
  render(){
    return(
      <>
      {this.state.productData.map(row=>{
   // alert(JSON.stringify(row.disconnect.data[0]))
        return(
          <Subscribe title={row.softwareidentificationname} serverid={row.uniqueregisterserverid===''?'':row.uniqueregisterserverid} status={row.disconnect.data[0]===0?row.uniqueregisterserverid!==""? "Active":"Not Active":"DISCONNECT"} color={row.uniqueregisterserverid!==""? "green":"red"}
          date={row.date} time={row.time}
            Key={row.productkey} copy={() => {
              navigator.clipboard.writeText(row.productkey)}}
            customer={<Expand companyname={row.companyname} email={row.emailid} mobileno={row.phonenumber} noofsystem={row.noofsystem}
            noofmobileuser={row.noofmobileuser} supportpin={row.supportpin}  productkey={row.productkey}
            onClick={row.disconnect.data[0]===0?()=>this.onModelClick(row.productcode,row.supportpin,row.productkey,):()=>this.disconnectsurrendar(row.productkey)}
            onDisconnect={row.disconnect.data[0]===0?()=>this.onDisconnect(row.productkey):()=>this.disconnectsurrendar(row.productkey)} />}/> 
        )
        })
      }
      <ModalTransition>
        {this.state.modalOpen && (
          <Modal>
              <Grid container spacing={2}>
                <Grid item xs={4} md={4}/>
                  <Grid item  style={{  width: '1150%',height:"100%" }} xs={12} md={4} sm={12}>
                    <Box  p={1} style={{width:'100%'}}>
                      <div className="greyBox" style={{width:'95%'}}>
                        <div className="row">
                          <div className="col-sm-11">
                            {/* <h5 style={{paddingLeft:'1%',margin:'auto'}} className="lato-font"> Reset Password</h5>*/}
                          </div>
                        </div>
                      </div>
                    </Box>
                  </Grid>
                  <Grid item xs={4} md={4}/>
                </Grid>
                <Grid container spacing={2}>
                  <Grid item xs={4} md={3}/>
                  <Grid item xs={12} sm={12} md={6}>
                    <FormControl sx={{ m: 1, width: '85%' }}>
                      <label style={{paddingBottom:'10px'}}>Supportpin</label>
                      <Textfield
                        fullWidth
                        value={this.state.changePin}
                        variant="outlined"
                        onChange={(evt)=>this.setState({changePin:evt.target.value})}
                      />
                    </FormControl>
                    <Grid item xs={4} md={3}/>
                  </Grid>
                </Grid>
                <Grid container spacing={2}>
                  <Grid item xs={4} md={4}/>
                  <Grid item xs={12} sm={12} md={4}>
                    <div className="button">
                      <Button  variant="contained" style={{color:'white',width:'70%'}} onClick={this.onPinChange}>Submit</Button>
                    </div>
                  </Grid>
                  <Grid item xs={4} md={4}/>
                </Grid><br/>
              </Modal>
              )}
            </ModalTransition>
         
            <ModalTransition > 
              {this.state.disConnectBox && (
                <Modal>
                  <Button appearance="link"  style={{marginLeft:"90%"}}  onClick={this.closedisconnect}>
                    <CrossIcon
                      label="Close Modal"
                    />
                  </Button>
                  <Box sx={this.state.style}>
                    <Grid container spacing={2}>
                    <Grid item xs={4} md={3}/>
                        <Grid item xs={12} sm={12} md={6}>
                        <FormControl sx={{ m: 1, width: '85%' }}>
                        <label style={{paddingBottom:'10px'}}>Password</label>
                        <Textfield
                        fullWidth
                        type="password"
                        value={this.state.password}
                        variant="outlined"
                        onChange={(evt)=>this.setState({password:evt.target.value})}
                      />
                      </FormControl>
                        <Grid item xs={4} md={3}/>
                        </Grid>
                        </Grid>
                        <Grid container spacing={2}>
                        <Grid item xs={4} md={4}/>
                        <Grid item xs={12} sm={12} md={4}>
                    <div className="button">
                        <Button  variant="contained" style={{color:'white',width:'70%'}} onClick={this.licenseDisconnect}>Submit</Button>
                    </div>
                    </Grid>
                    <Grid item xs={4} md={4}/>
                    </Grid>
                    <br/>
                  </Box>
                </Modal>
              )}
              </ModalTransition>
           
              <ModalTransition>
                {this.state.recordmodel && (
                <Modal >
                  <ModalHeader>
                     Subscription
                  </ModalHeader>
                  <ModalBody>
                       No Records Found
                  </ModalBody>
                  <ModalFooter>
                  <Button appearance="primary" onClick={this.onrecordmodelclose} autoFocus>OK</Button>
                  </ModalFooter>
                </Modal>
                )}
            </ModalTransition>
      </>
    )
  }
}



